export default class AtividadeOcorrencia {

  constructor(
    IdEmpresa = 1,
    IdOcorrencia = null,
    IdAtividade = null,
    Descricao = '',
    DataOcorrencia = new Date(),
    IdColaborador = null,
    Colaborador = '',
    Duracao = new Date(1970, 0, 1, 0, 0, 0),
    DescricaoAtividade = '',
    IdTipoOcorrencia = 1,
    TipoOcorrencia = 'GERAL',
    Status = 'A'
  ) {

    this.IdEmpresa = IdEmpresa;
    this.IdOcorrencia = IdOcorrencia;
    this.IdAtividade = IdAtividade;
    this.Descricao = Descricao;
    this.DataOcorrencia = DataOcorrencia;
    this.IdColaborador = IdColaborador;
    this.Colaborador = Colaborador;
    this.Duracao = Duracao;
    this.DescricaoAtividade = DescricaoAtividade;
    this.IdTipoOcorrencia = IdTipoOcorrencia;
    this.TipoOcorrencia = TipoOcorrencia;
    this.Status = Status;
  }
  
}